import { OperationRequest } from "../operations/operation-request";
import { Routes } from "../routes";
import { Strategy } from "./abstract-strategy";

export class SamlStrat extends Strategy {
    public hasCondition(request: OperationRequest): boolean {
        const hasTokenSAML = request.hasTokenSAML;
        if (hasTokenSAML) return true;
        return false;
    }

    public setStrategy(request?: OperationRequest): void {
        const documents = request?.documentList?.filter((doc) => doc.type === 1)[0];
        const route = request.documentList?.length > 1 ? documents.idDocument : request.idDocument;
        this.pathToGo = `${Routes.DOCUMENT}/${route}`;
    }
}